import { fileDeleteApi } from "Api/common";
import { StatusCodes } from "http-status-codes";
import moment from "moment";
import { toast } from "react-toastify";
import { QuotationKey } from "./Quotation";
import {
  fileLimitErrorMessage,
  fileTypePDFJPGPNGErrorMessage,
} from "./validation";

export const Search = "Search";
export const areYouSureLabel = "Are you sure ?";
export const areYouSureDescLabel = "Do you want to delete the record?";
export const closeLabel = "Close";
export const deleteLabel = "Yes, Delete It!";
export const Enter = "Enter";
export const ItemsPerPage = "Items per page";
export const Showing = "Showing";
export const of = "of";
export const Results = "Results";
export const to = "to";
export const Loading = "Loading...";
export const saveButton = "Save";
export const contactLabel = "Contact";
export const profileTitle = "Profile";
export const SEND_LABEL = "Send";
export const DISCARD_LABEL = "Discard";
export const SUBJECT_LABEL = "Subject";
export const NA = "N/A";
export const altImageText = "Header Avatar";
export const notFound = {
  dataNotFound: "Sorry! No Result Found",
  nullData: "---",
  notAvailable: "NA",
  somethingWrong: "Something went wrong.",
  thereIsNoDataFound: "No data found, Please try again!",
  trySearchingWithAnotherKeyword: "Try searching with another keyword!",
};
export const Admin = "admin";
export const labels = {
  welcome: "Welcome Back !",
  signIn: "Sign in to continue to Building Machine Elements.",
  shivInfo: "Machine Elements",
};

export const userTab = {
  personalDetails: " Personal Details",
  ChangePassword: "Change Password",
};

export const loginLabels = {
  Email: "Email",
  email: "email",
  Password: "Password",
  password: "password",
  OTP: "OTP",
  otp: "otp",
  ConfirmPassword: "Confirm password",
  confirmPassword: "confirm_password",
  createNewPassword: "Create new password",
  token: "token",
  authUser: "authUser",
  Role: "role",
  Id: "id",
  Permissions: "permissions",
  clickHere: "Click here",
  loginNavigateMessage: "Wait, I remember my password...",
  verifyEmailMessage: "Enter your email and instructions will be sent to you!",
  login: "Login",
  verifyEmail: "Verify Email",
  forgotPassword: "Forgot Password",
  forgotPasswordLabel: "Forgot password",
  forgetPassword: "Forget Password",
  sendOtp: "Send OTP",
  signIn: "Sign In",
  resetPassword: "Reset Password",
  CurrentPassword: "Current Password",
  NewPassword: "New password",
  ConfirmNewPassword: "Confirm New password",
  currentPassword: "currentPassword",
  newPassword: "newPassword",
  confirmPasswordName: "confirmPassword",
  changePassword: "Change Password",
  streetAddress: "Street Address",
  personalDetails: "Personal Details",
};

export const checkStatusCodeSuccess = (data: any) => {
  if (data === StatusCodes.OK || StatusCodes.ACCEPTED || StatusCodes.CREATED) {
    return true;
  } else {
    return false;
  }
};

export const PaymentMode = [
  { id: 1, value: "Cod", label: "Cod" },
  { id: 2, value: "Card Payment", label: "Card Payment" },
  { id: 3, value: "Upi Payment", label: "UPI Payment" },
  { id: 4, value: "Bank Transfer", label: "Bank Transfer" },
];

export const PaymentStatus = [
  { id: 1, value: "Pending", label: "Pending" },
  { id: 2, value: "Partially Paid", label: "Partially Paid" },
  { id: 3, value: "Paid", label: "Paid" },
  { id: 4, value: "Partially Refunded", label: "Partially Refunded" },
  { id: 5, value: "Refunded", label: "Refunded" },
];
export const TaxType = [
  { id: 1, value: "5_Inter", label: "IGST [5%]" },
  { id: 2, value: "10_Inter", label: "IGST [10%]" },
  { id: 3, value: "18_Inter", label: "IGST [18%]" },
  { id: 4, value: "28_Inter", label: "IGST [28%]" },
  { id: 5, value: "5_Intra", label: "CGST + SGST [5%]" },
  { id: 6, value: "10_Intra", label: "CGST + SGST [10%]" },
  { id: 7, value: "18_Intra", label: "CGST + SGST [18%]" },
  { id: 8, value: "28_Intra", label: "CGST + SGST [28%]" },
];

export const moduleName = {
  Public: "Public",
  Configuration: "Configuration",
  Dashboard: "Dashboard",
  Material: "Material",
  Make: "Make",
  Vendor: "Vendor",
  Customers: "Customers",
  Technician: "Technician",
  Staff: "Staff",
  Service: "Service",
  HsnSac: "HSN SAC",
  Product: "Product",
  MaterialGroup: "Material Group",
  Generation: "Generation",
  Received: "Received",
  Orders: "Orders",
  Project: "Project",
  JobCard: "Job Card",
  Reports: "Reports",
  Store: "Store",
  EmailComposePage: "Compose Email",
  Profile: "Profile",
  ChangePassword: "Change Password",
  RepairOrderOpening: "Repair Order Opening",
  PartsIssueDetaiils: "Parts Issue Details",
  RepairOrderClosing: "Repair Order Closing",
  RepairOrderReopen: "Repair Order Reopen",
  Quotation: "Quotation",
  WorkOrder: "Work Order",
  ProformaInvoice: "Proforma Invoice",
  TaxInvoice: "Tax invoice",
  CreditNote: "Credit Note",
  PurchaseOrder: "Purchase Order",
  ReturnRepairOrder: "Return Repair Order",
  ReturnPurchaseOrder: "Return Purchase Order",
};

export const NormalDate = (date: string) => {
  return moment(date).format("YYYY-MM-DD");
};

export const currentDate = NormalDate(new Date().toISOString());

export const errorHandler = (err: any) => {
  if (Array.isArray(err?.response?.data?.message)) {
    err?.response?.data?.message?.map((message: string) => {
      toast.error(message);
    });
  } else {
    toast.error(err?.response?.data?.message || err?.message);
  }
};

export const validateTable = (
  data: any[],
  columns: any[],
  updateRows: (rows: any[]) => void,
  updateValidity: (isValid: boolean) => void
): boolean => {
  let isValid = true;
  const serviceFields = [
    QuotationKey.ProductName,
    QuotationKey.DescriptionSubHead,
    QuotationKey.Quantity,
    QuotationKey.Per,
  ];
  const productFields = [QuotationKey.ServiceName];

  const updatedRows = data?.map((row: any) => {
    const excludeFields = row?.isService ? serviceFields : productFields;
    const rowErrors: Record<string, boolean> = {};
    columns?.forEach((col: any) => {
      const field = col.field;
      if (
        col.editable &&
        field &&
        !row[field] &&
        !excludeFields.includes(field)
      ) {
        rowErrors[field] = true;
        isValid = false;
      }
    });
    return { ...row, errors: rowErrors };
  });
  updateRows(updatedRows);
  updateValidity(isValid);
  return isValid;
};

export const rupeeSymbol = (value: any) => {
  return `₹ ${value}`;
};

export const TableErrorMessage = "Please fill all the data in table.";
export const LogoutMessage = "Are you sure you want to log out?";
export const ProductErrorMessage = "Please select Product or Service.";
export const DownloadLabel = "Download";
export const allowedTypes = ["application/pdf", "image/jpeg", "image/png"];

export const fileDownload = (resp: any, type: any, fileName: string) => {
  const blob = new Blob([resp], { type: type });
  const url = window.URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = fileName;
  a.target = "_blank";
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
};
export const blobResponse: any = {
  responseType: "blob",
};
export const blobErrHandler = async (err: any) => {
  const error = await err?.response?.data?.text();
  if (error) {
    const errorMessage = JSON.parse(error);
    toast.error(errorMessage?.message);
  }
};
export const pdfDownload = (
  api: any,
  id: number,
  fileName: string,
  setLoader: any
) => {
  setLoader(true);
  api(id)
    .then((res: any) => {
      if (checkStatusCodeSuccess(res)) {
        const type = "application/pdf";
        fileDownload(res?.data, type, fileName);
        toast.success(res);
      }
    })
    .catch((err: any) => {
      blobErrHandler(err);
    })
    .finally(() => {
      setLoader(false);
    });
};

export const deleteUploadedFile = (
  fileName: string,
  isFolder?: boolean,
  folderDirectory?: string
) => {
  type Payload = {
    generatedFileNames: string[];
    folderPath?: string;
  };
  const payload: Payload = {
    generatedFileNames: [fileName],
  };
  if (isFolder) {
    payload.folderPath = folderDirectory;
  }
  setTimeout(() => {
    if (fileName) {
      fileDeleteApi(payload)
        .then((resp) => {
          if (checkStatusCodeSuccess(resp?.StatusCode)) {
            return true;
          } else {
            return false;
          }
        })
        .catch((err) => {
          return err;
        });
    }
  }, 2000);
};

export const grnFileValidation = (file: File) => {
  const maxSizeInBytes = 1024 * 1024;

  if (file && file.size > maxSizeInBytes) {
    return fileLimitErrorMessage;
  }
  if (!allowedTypes.includes(file.type)) {
    return fileTypePDFJPGPNGErrorMessage;
  }
  return null;
};

export const mapToDropdownOptions = (
  data: any[],
  valueKey: string,
  labelKey: string
) => {
  return data?.map((item: any) => ({
    value: item?.[valueKey],
    label: item?.[labelKey],
    id: item?.[valueKey],
  }));
};
